import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import { useGetReferralsList } from '@/query/queries/marketing/useGetReferralsList';
import { useWindowSize } from '@/hooks/useWindowSize';
import ReferralTable from './ReferralTable';
import ReferralList from './ReferralList';
import './index.scss';

export const ReferralFriendStatus = ({ status }) => {
  const { t } = useTranslation('affiliate');
  return {
    registered: t('friend_status.registered'),
    invested: t('friend_status.invested'),
    invested_less: t('friend_status.invested_less'),
  }[status];
};

const ReferralModule = () => {
  const { t } = useTranslation('affiliate');
  const { innerWidth } = useWindowSize();

  const {
    data: referralsList,
    hasNextPage,
    fetchNextPage,
    isLoading,
  } = useGetReferralsList();

  const hasReferrals = !!referralsList?.pages[0]?.total_count;

  return (
    <div className="referrals_module">
      {!hasReferrals && !isLoading && (
        <div className="referrals_module__empty f-16">
          {t('no_referrals_yet')}
        </div>
      )}

      {isLoading ? (
        <Preloader className="referrals_module__preloader" />
      ) : (
        hasReferrals &&
        (innerWidth < 992 ? (
          <ReferralList data={referralsList} />
        ) : (
          <ReferralTable data={referralsList} />
        ))
      )}

      {hasNextPage && (
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className="referrals_module__more f-24 f-500"
            onClick={fetchNextPage}
          >
            {t('load_more')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ReferralModule;
